import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
import PlayerButton from '../PlayerButton/PlayerButton';
import './ViewModeButton.scss';

function ViewModeButton({
  isFullScreenMode,
  handleToggleFullScreen,
  enterFullscreenTooltip,
  exitFullscreenTooltip,
}) {
  return (
    <PlayerButton
      className="dtv-common-c-view-mode-button-v2"
      onClick={handleToggleFullScreen}
      tooltip={isFullScreenMode ? exitFullscreenTooltip : enterFullscreenTooltip}
    >
      <Icon name={isFullScreenMode ? 'exit-fullscreen' : 'fullscreen'} />
    </PlayerButton>
  );
}

ViewModeButton.propTypes = {
  isFullScreenMode: PropTypes.bool,
  handleToggleFullScreen: PropTypes.func,
  enterFullscreenTooltip: PropTypes.string,
  exitFullscreenTooltip: PropTypes.string,
};

ViewModeButton.defaultProps = {
  isFullScreenMode: false,
  handleToggleFullScreen() {},
  enterFullscreenTooltip: '',
  exitFullscreenTooltip: '',
};

export default ViewModeButton;
